import { yupResolver } from '@hookform/resolvers/yup'
import { formatCurrencyNoDecimals } from '@if/core/utils'
import { InputText } from '@src/components'
import { Constants } from '@src/types'
import { useForm } from 'react-hook-form'
import { Trans, useTranslation } from 'react-i18next'
import { LoanAmountInput, LoanAmountInputSchema } from './PrequalificationSchema'
import { FORM_ID } from './StepperFormFooter'

interface Props {
  prequalificationData: LoanAmountInput
  onPrequalificationUpdated: (data: LoanAmountInput) => void
}

const LoanAmountForm = ({ prequalificationData, onPrequalificationUpdated }: Props) => {
  const { t, i18n } = useTranslation()
  const lang = i18n.language
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<LoanAmountInput>({
    mode: 'onBlur',
    resolver: yupResolver(LoanAmountInputSchema),
    defaultValues: prequalificationData,
  })

  return (
    <section className="step-content">
      <h3 className="form-question">{t('loanAmount.desiredAmount')}</h3>
      <div className="paragraph">
        <p>
          <Trans
            i18nKey="loanAmount.amountThresholds"
            values={{
              minLoanAmount: formatCurrencyNoDecimals(Constants.MinLoanAmount),
              maxLoanAmount: formatCurrencyNoDecimals(Constants.MaxLoanAmount),
            }}
          />
        </p>
      </div>

      <form onSubmit={handleSubmit(onPrequalificationUpdated)} id={FORM_ID} noValidate>
        <InputText
          id="requestedLoanAmountInput"
          type="number"
          error={errors.requestedLoanAmount}
          label={t('loanAmount.amount')}
          wrapStyle={lang === 'en' ? 'number-wrap startwith' : 'number-wrap endwith'}
          {...register('requestedLoanAmount')}
        />
      </form>
    </section>
  )
}

export default LoanAmountForm
